import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import CommonDialogComponent from './components/dialog';
import CommonDrawerComponent from './components/drawer';
import ReduxProvider from './providers/ReduxProvider';
import AppRoute from './routes/AppRoute';
import Snackbar from './components/common/SnackbarMessage';
import { SettingsProvider } from './providers/SettingsProvider';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect } from 'react';
import { hitUserCount } from './utils/services/registration/donor-registration.service';

const App = () => {

    useEffect(() => {
        const handleContextMenu = (e: MouseEvent) => { e.preventDefault(); };
        document.addEventListener('contextmenu', handleContextMenu);
        return () => { document.removeEventListener('contextmenu', handleContextMenu); };
    }, []);

    useEffect(() => {
        const currentUrl = window.location.href;
        const hitGuestVisit = async () => {
            const res = await hitUserCount({});
            console.log(res);
        };
        hitGuestVisit();
        if (currentUrl === process.env.REACT_APP_WEB_BASE_URL || currentUrl === process.env.REACT_APP_WEB_BASE_URL_UAT || currentUrl === process.env.REACT_APP_WEB_BASE_URL_LIVE) {
        }
    }, []);

    return (
        <SettingsProvider>
            <ReduxProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Router>
                        <Routes>
                            <Route path='*' element={<AppRoute />} />
                        </Routes>
                        <CommonDrawerComponent />
                        <CommonDialogComponent />
                    </Router>
                    <Snackbar />
                </LocalizationProvider>
            </ReduxProvider>
        </SettingsProvider>
    )
}

export default App;